/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewSubscriptionsListResponse } from '../models/NewSubscriptionsListResponse';
import type { OnlyFansList } from '../models/OnlyFansList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NewSubscriptionsListDashboardRestEndpointService {
    /**
     * @returns NewSubscriptionsListResponse OK
     * @throws ApiError
     */
    public static newSubscriptionsListResponse({
        onlyfansId,
    }: {
        onlyfansId: number,
    }): CancelablePromise<NewSubscriptionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creator/new-subs-list/{onlyfansId}',
            path: {
                'onlyfansId': onlyfansId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static setNewSubsList({
        onlyfansId,
        requestBody,
    }: {
        onlyfansId: number,
        requestBody: OnlyFansList,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/new-subs-list/{onlyfansId}',
            path: {
                'onlyfansId': onlyfansId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static removeNewSubsList({
        onlyfansId,
    }: {
        onlyfansId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/creator/new-subs-list/{onlyfansId}',
            path: {
                'onlyfansId': onlyfansId,
            },
        });
    }
}
